<!-- @format -->

<div *transloco="let t" class="search-page container sis-pt-md">
  <div class="search-title row">
    <div class="col-12">
      <h2 data-cy="page-secondary-title">{{ "SEARCH_PAGE_CROSS_STUDY_TITLE" | translate }}</h2>
    </div>
  </div>
  <p class="guidance">{{ "SEARCH_CROSS_STUDY_GUIDANCE" | translate: { name: currentUniversity$ | async | localizeProperty: "name" } }}</p>

  <div class="search-and-results scroll-target">
    <sis-search
      [guidance]="'COURSE_UNIT_SEARCH_PLACEHOLDER'"
      (searchTrigger)="onSearchParameterChange($event)"
      [searchResult]="searchResult$ | async">
      <ng-template sisSearchFilter>
        <sis-search-filter-cooperation-networks [key]="'cooperationNetworkId'" [label]="t('SEARCH.FILTER_TAGS.COOPERATION_NETWORK')" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-universities
          [key]="'targetUniversityId'"
          [label]="t('SEARCH.FILTER_TAGS.COOPERATION_NETWORK_UNIVERSITY')"
          [excludedUniversityIds]="currentUniversityOrgId" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-code-book
          [key]="'curCodeUrn'"
          [label]="t('SEARCH.FILTER_TAGS.TEACHINGLANGUAGE')"
          [codeBookUrn]="'urn:code:language'" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-study-periods [key]="'activityPeriod'" [label]="t('SEARCH.FILTER_TAGS.ACTIVITYPERIODS')" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-code-book
          [key]="'studyField'"
          [label]="t('SEARCH.FILTER_TAGS.STUDYFIELDURNS')"
          [codeBookUrn]="'urn:code:study-field'"
          [optionValueRegexFilter]="'okm-\\d+$'" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-combobox
          [key]="'enrolmentPeriodValidity'"
          [label]="t('SEARCH.FILTER_TAGS.ENROLMENTPERIODS')"
          [options]="enrolmentPeriodOptions" />
      </ng-template>
    </sis-search>

    <sis-search-results>
      @if (searchResult$ | async; as searchResult) {
        <div class="below-searchbar row">
          @if (!searchResult.truncated && searchResult?.total > 0) {
            <div class="results-info col-12">
              <div class="row">
                <sis-search-result-counts
                  [id]="'results-show-guide'"
                  [showMoreEnabled]="false"
                  [searchResult]="searchResult"
                  [resultHeadingLevel]="2"></sis-search-result-counts>
                <div class="col-12 col-sm-6">
                  <div class="float-start float-sm-end">
                    <label id="sort-method-dropdown-label" class="choose-sort-type" translate
                      >SEARCH.SORT_SELECTOR.CHOOSE_SORT_METHOD</label
                    >
                    <sis-dropdown-select
                      [ariaLabelledBy]="'sort-method-dropdown-label'"
                      [options]="searchSortOptions"
                      [selection]="searchService.sort$ | async"
                      (selectionChange)="sort($event)"
                      [alignRight]="true"
                      data-cy="sort-search-results">
                    </sis-dropdown-select>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="results col-12">
            @for (result of searchResult?.searchResults | slice: 0 : resultsPerPage; track result) {
              <div data-cy="student-courseunit-search-resultrow">
                <app-search-cooperation-network-result-row
                  [result]="result"
                  [term]="searchService.fullTextQuery$ | async"
                  [courseCartCourseIds]="courseCartCourseUnitIds"
                  [loggedIn]="isLoggedIn()"
                  (addCourseUnitToCourseCart)="addCourseUnitToCourseCart($event)"
                  (removeCourseUnitFromCourseCart)="removeCourseUnitFromCourseCart($event)">
                </app-search-cooperation-network-result-row>
              </div>
            }
          </div>
        </div>
        @if (!searchResult.truncated && searchResult?.total > this.resultsPerPage) {
          <div class="search-result-pagination row">
            <div class="col-12" data-cy="pagination-controls">
              <sis-pagination
                sisScrollIntoViewOnPageChange="div.scroll-target"
                [totalItems]="searchResult.total"
                [maxSize]="5"
                [itemsPerPage]="resultsPerPage"
                [currentPage]="currentPage"
                (currentPageChange)="onPaginationChange($event)">
              </sis-pagination>
            </div>
          </div>
        }
      }
    </sis-search-results>
  </div>
</div>
